<template>
  <div class="container section-padding">
    <div v-if="processing">
      <div class="row space-loader d-flex align-items-center justify-content-center">
        <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <form v-else @submit.prevent="processForm">
      <div class="row">

        <div class="col-lg-12">
          <h2 class="space-bottom">Product Details</h2>
          <MediaLibraryModal v-on:mediaSelected="mediaSelected" ref="mediaLibraryModal" />
          <div class="form-group">
            <label for="type">Product Type:</label>
            <select class="form-control" id="type" v-model="product.type">
              <option value="car">Car</option>
              <option value="electronic">Electronic</option>
              <option value="engine">Engine</option>
              <option value="helicopter">Helicopter</option>
              <option value="kit">Kit</option>
              <option value="plane">Plane</option>
              <option value="spare">Spare</option>
              <option value="steam">Steam</option>
              <option value="tool">Tool</option>
              <option value="train">Train</option>
            </select>
          </div>
          <div v-if="product.type == 'engine'" class="form-group">
            <label for="type">Engine Type:</label>
            <select class="form-control" id="type" v-model="engineType">
              <option value="diesel">Diesel</option>
              <option value="gas">Gas</option>
              <option value="glow">Glow</option>
            </select>
          </div>
          <div class="form-group">
            <label for="title">Title:</label>
            <input v-model="product.title" type="text" class="form-control" id="title" placeholder="Title" />
          </div>
          <div class="form-group">
            <label for="price">Price:</label>
            <input v-model="product.price" type="number" step="0.01" class="form-control" id="price"
              placeholder="Price" />
          </div>

          <div class="form-group">
            <label for="description">Description:</label>
            <textarea rows="4" v-model="product.description" type="text" class="form-control" id="description"
              placeholder="Description"></textarea>
          </div>
          <div class="form-group space-bottom">
            <label for="status">Status:</label>
            <select class="form-control" id="status" v-model="product.status">
              <option value="listed">Listed</option>
              <option value="reserved">Reserved</option>
              <option value="sold">Sold</option>
            </select>
          </div>
        </div>
        <div class="col-lg-12 space-bottom space-top">
          <h2 class="space-bottom">Product Media</h2>
          <div class="d-flex justify-content-between align-items-center">
            <div style="max-width: 50%;">
              <label style="font-weight:600">Pictures:</label>
              <p>Click on an image to select it as the product thumbnail.</p>
            </div>
            <div>
              <button @click="$refs.file.click()" type="button" class="btn btn-info">Upload New</button>
              <button v-on:click="showMediaLibraryModal()" type="button" class="btn btn-info space-left">
                Select From Library
              </button>
            </div>
          </div>
        </div>



        <div v-for="(media, mediaIndex) in productMedia" :key="mediaIndex" class="col-lg-4 space-top-small">
          <div :id="'picture' + mediaIndex" class="media-thumbnail" style="cursor:pointer;"
            v-on:click="selectThumbnail(media);" v-bind:style="'background-image: url(' + src(mediaIndex) + ')'"></div>
          <button style="width:100%" v-on:click="removeSelectedMedia(mediaIndex)" type="button"
            class="btn btn-danger">Remove Image</button>

        </div>


        <div class="col-lg-12 space-top">
          <hr>
          <input v-on:change="uploadMedia" id="file-input" ref="file" type="file" style="display:none;" />
          <div v-if="errorMessage != ''" style="color: red">{{errorMessage}}</div>
          <button type="submit" class="btn btn-primary space-top">Save</button>
          <button @click="$router.go(-1)" type="button" class="btn btn-danger space-left space-top">Cancel</button>
        </div>





      </div>
    </form>
  </div>
</template>

<script>
  import api from "../../api/api";
  import MediaLibraryModal from "@/components/Admin/MediaLibraryModal.vue";

  export default {
    components: {
      MediaLibraryModal,
    },
    props: {
      productID: {
        type: String,
        default: null,
      },
    },
    data: function () {
      return {
        product: {
          id: "",
          title: "",
          price: 0,
          description: "",
          status: "listed",
          type: "car",
        },
        engineType: null,
        productMedia: {},
        selectedThumbnail: null,
        processing: false,
        errorMessage: "",
        currentThumbID: ""
      };
    },
    mounted() {
      if (this.$props.productID != null) {
        this.processing = true;
        api
          .getProduct(this.$props.productID)
          .then((res) => {
            this.product = res;
            if (res.type == "engine") {
              this.engineType = res.metadata.engine_type;
            }
            for (var i = 0; i < res.media.length; i++) {
              this.$set(this.productMedia, res.media[i].id, res.media[i]);
              if (res.metadata.thumbnail == res.media[i].id) {
                this.selectedThumbnail = res.media[i];

              }
            }
          })
          .catch((err) => {
            this.errorMessage = err;
          })
          .finally(() => {
            this.processing = false;

            this.$nextTick(function () {
              var elementStart = document.getElementById('picture' + this.selectedThumbnail.id);
              elementStart.classList.add("selectedThumb");
            })
          });
      }
    },
    methods: {
      setThumb() {

      },
      uploadMedia() {
        this.processing = true;
        api
          .createMedia(this.$refs.file.files[0])
          .then((res) => {
            this.$set(this.productMedia, res.media.id, res.media);
          })
          .finally(() => {
            this.processing = false;
          });
      },
      selectThumbnail(thumbnail) {
        
        if (this.selectedThumbnail != null) {
          var element = document.getElementById('picture'+this.selectedThumbnail.id);
          element.classList.remove("selectedThumb");
        }
        this.currentThumbID = "picture" + thumbnail.id
        var elementNew = document.getElementById(this.currentThumbID);
        elementNew.classList.add("selectedThumb");
        this.selectedThumbnail = thumbnail;
      },
      src(id) {
        return (
          process.env.VUE_APP_API_URL + "/media/thumbnails/300/" + id + ".png"
        );
      },
      mediaSelected(media) {
        for (var i = 0; i < media.length; i++) {
          this.$set(this.productMedia, media[i].id, media[i]);
        }
      },
      removeSelectedMedia(id) {
        this.$delete(this.productMedia, id);
        if (this.selectedThumbnail.id == id) {
          this.selectedThumbnail = null;
        }
      },
      showMediaLibraryModal() {
        this.$refs.mediaLibraryModal.show();
      },
      hideMediaLibraryModal() {
        this.$refs.mediaLibraryModal.hide();
      },
      validateForm() {
        let error = "";
        this.errorMessage = "";
        if (this.product.type == "") {
          error = error + "Must select a product type.\n";
        }
        if (this.product.type == "engine" && this.engineType == "") {
          error = error + "Must select an engine type.\n";
        }
        if (this.product.title == "") {
          error = error + "Title may not be empty.\n";
        }
        if (this.product.price == 0) {
          error = error + "Price may not be zero.\n";
        }
        if (this.selectedThumbnail == null) {
          error = error + "You must select a thumbnail.\n";
        }
        if (error != "") {
          this.errorMessage = error;
          return false;
        }
        return true;
      },
      processForm() {
        if (!this.validateForm()) {
          return;
        }

        const data = this.product;
        data.price = parseFloat(data.price);
        data.media = [];
        data.metadata = {
          thumbnail: this.selectedThumbnail.id,
        };
        if (data.type == "engine") {
          data.metadata.engine_type = this.engineType;
        }
        for (var key in this.productMedia) {
          data.media.push(key);
        }
        this.$emit("submitted", data);
      },
    },
  };
</script>